import { render, staticRenderFns } from "./AlertPjsModal.vue?vue&type=template&id=7eb37281&lang=pug&"
import script from "./AlertPjsModal.vue?vue&type=script&lang=js&"
export * from "./AlertPjsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports